export const IS_DEVELOPMENT = import.meta.env.MODE === 'development';

// Brand mode from build-time environment variable (for mobile apps)
export const BRAND_MODE = import.meta.env.VITE_BRAND_MODE;

// Platform detection
export const IS_MOBILE_APP = !!(window as any).ReactNativeWebView || 
  !!(window as any).webkit?.messageHandlers || 
  !!(window as any).Android ||
  navigator.userAgent.includes('wv') || // WebView indicator
  navigator.userAgent.includes('Mobile') && window.location.protocol === 'file:';

export const IS_WEBSITE = !IS_MOBILE_APP;

// More specific platform detection
export const IS_IOS_APP = !!(window as any).webkit?.messageHandlers;
export const IS_ANDROID_APP = !!(window as any).Android;